/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutQuote
 */
export interface CarveOutQuote {
    /**
     * 
     * @type {string}
     * @memberof CarveOutQuote
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutQuote
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutQuote
     */
    document_name?: string;
}

/**
 * Check if a given object implements the CarveOutQuote interface.
 */
export function instanceOfCarveOutQuote(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "document_id" in value;

    return isInstance;
}

export function CarveOutQuoteFromJSON(json: any): CarveOutQuote {
    return CarveOutQuoteFromJSONTyped(json, false);
}

export function CarveOutQuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutQuote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document_id': json['document_id'],
        'document_name': !exists(json, 'document_name') ? undefined : json['document_name'],
    };
}

export function CarveOutQuoteToJSON(value?: CarveOutQuote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'document_id': value.document_id,
        'document_name': value.document_name,
    };
}

